import { render, staticRenderFns } from "./ShipmentInspectList.vue?vue&type=template&id=68d30454&"
import script from "./ShipmentInspectList.vue?vue&type=script&lang=js&"
export * from "./ShipmentInspectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports